import { mediaUrl } from "@/lib/api";
import MediaEmbed from "./MediaEmbed";
import RichAudio from "./RichAudio";
import { Download, ExternalLink } from "lucide-react";

function Block({ b }) {
  switch (b.type) {
    case "heading":
      return <h3 className="font-serif text-2xl sm:text-3xl text-[#3D3238] leading-tight">{b.text}</h3>;
    case "text":
      return (
        <div className="prose-unfiltered">
          {(b.text || "").split("\n\n").filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}
        </div>
      );
    case "image":
      return b.path ? (
        <figure>
          <img src={mediaUrl(b.path)} alt={b.caption || ""} className="w-full rounded-2xl border border-[rgba(61,50,56,0.08)]" />
          {b.caption && <figcaption className="text-sm text-[#8C7E83] mt-2 text-center italic">{b.caption}</figcaption>}
        </figure>
      ) : null;
    case "video":
      return (b.url || b.path) ? <div className="rounded-2xl overflow-hidden border border-[rgba(61,50,56,0.08)]"><MediaEmbed kind={b.media_kind} url={b.url} path={b.path} /></div> : null;
    case "audio":
      return <RichAudio cover={b.cover_path} title={b.title} subtitle={b.subtitle} path={b.path} />;
    case "file":
      return b.path ? (
        <a href={mediaUrl(b.path)} download target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-2 text-sm text-[#C6899E] border border-[rgba(198,137,158,0.4)] rounded-full px-5 py-2.5 hover:bg-[rgba(198,137,158,0.12)] transition-colors">
          <Download className="w-4 h-4" /> {b.label || "Scarica il file"}
        </a>
      ) : null;
    case "button":
      return b.url ? (
        <a href={b.url} target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-2 bg-[#C6899E] text-[#FBF5F1] rounded-full px-7 py-3 text-sm uppercase tracking-[0.15em] hover:bg-[#B4718C] transition-colors">
          {b.label || "Apri"} <ExternalLink className="w-4 h-4" />
        </a>
      ) : null;
    default:
      return null;
  }
}

export default function BlockRenderer({ blocks }) {
  if (!blocks || blocks.length === 0) return null;
  return (
    <div className="space-y-8" data-testid="block-renderer">
      {blocks.map((b) => <Block key={b.id} b={b} />)}
    </div>
  );
}
